import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { resolveLocale } from '../../../shared/i18n/date-format';
import { CHANGE_KIND_LABELS, CHANGELOG } from './changelog-entries';

@Component({
  selector: 'andor-changelog',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './changelog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './changelog.scss',
})
export class Changelog {
  readonly #translate = inject(TranslateService);
  readonly #lang = toSignal(this.#translate.onLangChange.pipe(map((e) => e.lang)), {
    initialValue: this.#translate.getCurrentLang() ?? this.#translate.getFallbackLang() ?? 'en',
  });

  protected readonly kindLabels = CHANGE_KIND_LABELS;
  protected readonly days = computed(() => {
    // Dates are calendar days, so format them in UTC to keep the day stable.
    const format = new Intl.DateTimeFormat(resolveLocale(this.#lang()), {
      dateStyle: 'long',
      timeZone: 'UTC',
    });
    return CHANGELOG.map((day) => ({
      ...day,
      label: format.format(new Date(`${day.date}T00:00:00Z`)),
    }));
  });
}
